import { Box, CloseButton, Drawer } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { ContextModalProps, modals } from "@mantine/modals";
import { FC, ReactNode, useEffect } from "react";

interface Props {
  c: ReactNode;
  leadStatus?: string;
  size?: number | string;
}

export const DrawerModal: FC<ContextModalProps<Props>> = ({
  context, id, innerProps,
}) => {
  const [opened, { open, close }] = useDisclosure(false);

  useEffect(() => {
    open();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Drawer 
      opened={opened} 
      onClose={() => {
        close();
        context.closeModal(id);
      }}
      position="bottom"
      variant={innerProps?.leadStatus 
        ? "baseball-card--red" 
        : "baseball-card"}
      title
      size={innerProps?.size || "lg"}
      zIndex={5000}
      p={0}
      radius="30px 30px 0 0">
        {innerProps?.leadStatus && (
          <Box 
            bg="red" 
            display="block" 
            w="100%"
            pos="absolute"
            top={0}
            left={0}
            lh="25px"
            ta="center"
            c="white">
            {innerProps?.leadStatus}
          </Box>
        )}
        <Box 
          p={0}
          mt={40}
          w="100%"
          pos="relative">
        {innerProps.c}
        <CloseButton 
          size="xl"
          pos="absolute" 
          top={-15} 
          right={-15}
          onClick={() => {
            close();
            context.closeModal(id);
          }}
          />
        </Box>
    </Drawer>
  )
};

export const openDrawerModal = (
  c: ReactNode,
  opt?: {
    leadStatus?: string,
    size?: string,
  },
): string => {
  return modals.openContextModal({
    modal: "drawerModal",
    innerProps: {
      c,
      leadStatus: opt?.leadStatus,
      size: opt?.size || "xl",
    },
    withOverlay: false,
    withCloseButton: false,
    variant: "baseball-card"
  });
};

export const closeDrawerModal = (id: string): void => {
  modals.close(id);
}

export default DrawerModal;
